module.exports = __webpack_public_path__ + "assets/img/adf23ad33fafd34e3517894b7d098662.svg";